import React from 'react';
import {FeedGallerySectionBlock} from './style';

const FeedGallerySection = (props) => {
    return <FeedGallerySectionBlock {...props}>{props.children}</FeedGallerySectionBlock>;
}

export default FeedGallerySection;